import { Modal, ModalFooter } from '@/src/components/Antd';
import React, { useMemo } from 'react';

import { request_productListInit } from '@/src/request/salesChannel/product';
import { unique } from '@/src/tools/helper';
import _ from 'lodash';
import { SizeFittingTable } from 'src/components/Antd';
import Filter, { FilterType } from 'src/components/FilterGroup/Filter';
import Pagination from 'src/components/StyledPagination/GlobalPagination';
import Tags from 'src/components/Tags/Tags';
import { useI18n } from 'src/hooks/useRouterChange';
import { defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { randomNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { EnumProductProperty } from 'src/types/common/product';
import NoProduct from './NoProduct';
import { collectionColumns } from './TableCommon';
import { useProductsHasUpdate } from './commonHooks';
import css from './css.less';
import {
  onSelectChange as _onSelectChange,
  updateMappedSelectedKeys as _updateMappedSelectedKeys,
  generateMappedSelectedKeys,
  generateScrollProps,
  generateTags,
  onOkClick,
} from './tools';
import { ProductSelectItem } from './types';

interface ISelectedItems {
  [propsName: string]: //uuid
  {
    current: boolean;
    checked: boolean;
    product?: ProductSelectItem;
  };
}

interface IProps {
  visible: boolean;
  selectedItems: ProductSelectItem[];
  onCancel: () => void;
  onOk: (item) => void;
  selectedProductsProperty?: EnumProductProperty;
  fixedSearchConditions?: { [propsName: string]: any };
  salesChannelUuid: string;
}

const CollectionProductsSelection = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    visible,
    onCancel,
    onOk,
    selectedItems = [],
    selectedProductsProperty,
    fixedSearchConditions,
    salesChannelUuid,
  } = props;

  // const [loading, setLoading] = React.useState(false);
  const [hasInit, setHasInit] = React.useState(false);
  const [taggedList, setTaggedList] = React.useState([]);
  const [collections, setCollections] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState('');
  const [searchList, setSearchList] = React.useState([]);
  const [current, setCurrent] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(defaultPageSize);
  const [filter, setFilter] = React.useState<any>({});
  const [products, setProducts] = React.useState<ProductSelectItem[]>([]);

  const currentProductsProperty =
    selectedProductsProperty || EnumProductProperty.Physical;
  const fixedSearchConditionsPhysical = {
    ...fixedSearchConditions,
  };

  React.useEffect(() => {
    // getProduct(() => {});
    request_productListInit(
      salesChannelUuid,
      current * pageSize,
      pageSize,
      fixedSearchConditionsPhysical,
    ).then((res) => {
      const {
        tags = [],
        collections = [],
        products: { totalCount = 0, results = [] } = {},
      } = res;
      const products = results.map((item) => {
        item.thumbnailUrl =
          item.thumbnailUrl ||
          (item.children && item.children[0]?.thumbnailUrl);
        item.children = null;
        return item;
      });

      setTaggedList(tags);
      setTotal(totalCount);
      setProducts(products);
      setHasInit(true);
      setCollections(collections);
    });
  }, []);
  const mappedProducts = React.useMemo(() => {
    return products.reduce((pre, now) => {
      return { ...pre, [now.uuid]: now };
    }, {});
  }, [products]);
  const [mappedSelectedKeys, setMappedSelectedKeys] =
    React.useState<ISelectedItems>(generateMappedSelectedKeys(selectedItems));

  const [selectedRowKeys, setSelectedRowKeys] = React.useState<
    {
      uuid: string;
      product?: ProductSelectItem;
    }[]
  >([]);

  const updateMappedSelectedKeys = React.useCallback(() => {
    return _updateMappedSelectedKeys(mappedSelectedKeys, selectedRowKeys);
  }, [mappedSelectedKeys, selectedRowKeys]);

  useProductsHasUpdate(
    products,
    setMappedSelectedKeys,
    setSelectedRowKeys,
    updateMappedSelectedKeys,
  );

  const onSelectChange = (selections) => {
    _onSelectChange(selections, mappedProducts, setSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys: selectedRowKeys.map((i) => i.uuid),
    onChange: onSelectChange,
    type:
      currentProductsProperty === EnumProductProperty.Virtual
        ? 'radio'
        : 'checkbox',
  };
  const getProduct = (cb) => {
    const {
      tags: taggedWithData = [],
      alias = [],
      collections: collectionsData = [],
    } = filter;

    const taggedWith = taggedWithData[0] ? taggedWithData[0].key : null;
    const _alias = alias[0] ? (alias[0] || {}).key : null;
    const _collections = collectionsData[0] ? collectionsData[0].key : null;
    request_productListInit(salesChannelUuid, current * pageSize, pageSize, {
      ...fixedSearchConditionsPhysical,
      searchText: searchList,
      tags: taggedWith ? [{ uuid: taggedWith }] : null,
      collections: _collections ? [{ uuid: _collections }] : null,
      alias: _alias === false ? _alias : _alias ? _alias : null,
    })
      .then((res) => {
        const { results, totalCount } = res.products;
        const productsAll = results.map((item) => {
          item.thumbnailUrl =
            item.thumbnailUrl ||
            (item.children && item.children[0]?.thumbnailUrl);
          item.children = null;
          return item;
        });

        setTotal(totalCount);
        const products: ProductSelectItem[] = productsAll.map((i) => {
          return {
            ...i,
            key: randomNumber(),
          };
        });

        setProducts(products);

        //setLoading(false);
      })
      .then(() => {
        if (cb) cb();
      });

    // console.log(product);
  };

  useAfterDidMountEffect(() => {
    setCurrent(0);
    setFilter({});
    setSearchList([]);
    setSelectedRowKeys([]);
  }, [currentProductsProperty]);

  useAfterDidMountEffect(() => {
    getProduct(() => {
      console.log('getProduct');
    });
  }, [filter, current, searchList]);

  useAfterDidMountEffect(() => {
    if (!current) {
      getProduct(() => {
        console.log('getProduct');
      });
    } else {
      setCurrent(0);
    }
  }, [pageSize]);

  const searchChange = () => {
    if (searchValue) {
      const searchListCopy = _.cloneDeep(searchList);
      searchListCopy.push(searchValue);
      setSearchList(unique(searchListCopy));
      setSearchValue('');
    }
  };
  const onPressEnter = () => {
    searchChange();
  };
  const onSearch = () => {
    searchChange();
  };
  const overlayClick = (checkedAll, list) => {
    const filterCopy = _.cloneDeep(filter);
    filterCopy[checkedAll.dataKey] = list;

    setFilter(filterCopy);
  };

  const pageOnChange = (index) => {
    if (index && index > 0) {
      setCurrent(index - 1);
    }
  };

  const pageSizeChange = (size) => {
    const { value } = size;

    setPageSize(value);
  };
  const onOkPress = React.useCallback(() => {
    onOkClick(updateMappedSelectedKeys, onOk, onCancel);
  }, [selectedRowKeys]);

  const tagClose = (e, index) => {
    const searchListCopy = _.cloneDeep(searchList);
    searchListCopy.splice(index, 1);
    setSearchList(searchListCopy);
  };

  const clearProductType = (key, index) => {
    const filterCopy = _.cloneDeep(filter);
    //TODO: 关闭tags
    // setProductType && setProductType('');
    filterCopy[key].splice(index, 1);
    setFilter(filterCopy);
  };

  const scrollProps = React.useMemo(() => {
    return generateScrollProps(products);
  }, [(products || []).length]);

  const tagText = useMemo(
    () => generateTags(filter, clearProductType),
    [filter],
  );

  const displayBody = () => {
    if (hasInit) {
      if ((products || []).length === 0) {
        return (
          <NoProduct
            text='No product has been found. Please create a  product first.'
            link={`/salesChannel/products/link/${salesChannelUuid}/null`}
          />
        );
      } else {
        return (
          <React.Fragment>
            <SizeFittingTable
              rowKey='uuid'
              pagination={false}
              id='ProductSetProductsSelectionTable'
              columns={collectionColumns({ getI18n })}
              dataSource={products}
              rowSelection={rowSelection}
              // loading={loading}
              scroll={scrollProps}
            />
            <Pagination
              current={current + 1}
              total={total}
              pageSize={pageSize}
              pageOnChange={pageOnChange}
              pageSizeChange={pageSizeChange}
              paginationProps={{ defaultPageSize: pageSize }}
            />
          </React.Fragment>
        );
      }
    }
    return <div />;
  };

  const filterList = [
    {
      type: FilterType.selection,
      name: getI18n('general.tags'),
      dataKey: 'tags',
      data: taggedList.map((item) => ({ name: item.name, key: item.uuid })),
    },
    {
      type: FilterType.selection,
      name: getI18n('general.type'),
      dataKey: 'alias',
      data: [
        //定义排序所需的数据
        { name: getI18n('general.original'), key: false },
        { name: getI18n('general.alias'), key: true },
      ],
    },
    {
      type: FilterType.selection,
      name: getI18n('general.collections'),
      dataKey: 'collections',
      data: collections.map((item) => ({
        name: item.collectionName,
        key: item.uuid,
      })),
    },
  ];

  return (
    <Modal
      title={getI18n('general.selectProduct')}
      visible={visible}
      width={900}
      onCancel={onCancel}>
      <div className={css.container}>
        <div className={css.filterContainer}>
          <Filter
            searchClassName={css.searchBar}
            searchValue={searchValue}
            filterList={filterList}
            searchOnchange={setSearchValue}
            pressEnter={onPressEnter}
            overlayClick={overlayClick}
            onSearch={onSearch}
          />
          <div className={css.searchContain}>
            <Tags onClose={tagClose} data={searchList} />
            {tagText}
          </div>
        </div>
        {displayBody()}
      </div>

      <ModalFooter
        okText={getI18n('general.linkModule.Modal.add')}
        cancelText={getI18n('general.cancel')}
        okClassName={css.okBtn}
        onOk={onOkPress}
        onCancel={onCancel}
      />
    </Modal>
  );
};
export default CollectionProductsSelection;
